export default __webpack_public_path__ + "ace40d73085ba6cdeea985f974711265.svg";